import styled from 'styled-components';
import media from '../../../../ui/media';
import luggageSvg from './static/luggage.inline.svg';
import passengerSvg from './static/passenger.inline.svg';
export const Root = styled.div.withConfig({
  displayName: "Style__Root",
  componentId: "sc-oqhgzm-0"
})(["margin-bottom:32px;font-size:", "px;&:last-child{margin-bottom:0;}", ""], ({
  theme: {
    fontSize
  }
}) => fontSize.md, media.xs`
    font-size: ${({
  theme: {
    fontSize
  }
}) => fontSize.sm}px;
  `);
export const Description = styled.div.withConfig({
  displayName: "Style__Description",
  componentId: "sc-oqhgzm-1"
})(["display:flex;flex-wrap:wrap;padding:0 20px;", ""], media.xs`
    flex-direction: column;
    padding-bottom: 2px;
  `);
export const DescriptionDirection = styled.div.withConfig({
  displayName: "Style__DescriptionDirection",
  componentId: "sc-oqhgzm-2"
})(["margin-right:29px;font-weight:500;", " ", ""], media.sm`
    margin-right: 15px;
  `, media.xs`
    margin-right: 0;
    margin-bottom: 2px;
  `);
export const Time = styled.div.withConfig({
  displayName: "Style__Time",
  componentId: "sc-oqhgzm-3"
})(["padding:3px 0 0 20px;"]);
export const LocalTimeInfo = styled.p.withConfig({
  displayName: "Style__LocalTimeInfo",
  componentId: "sc-oqhgzm-4"
})(["padding:3px 0 16px 20px;border-bottom:1px solid ", ";"], ({
  theme: {
    color
  }
}) => color.middleGray);
export const Item = styled.div.withConfig({
  displayName: "Style__Item",
  componentId: "sc-oqhgzm-5"
})(["position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding:14px 40px 10px 18px;border-bottom:1px solid ", ";", ""], ({
  theme: {
    color
  }
}) => color.middleGray, media.sm`
    padding-right: 20px;
  `);
export const Passenger = styled.div.withConfig({
  displayName: "Style__Passenger",
  componentId: "sc-oqhgzm-6"
})(["display:flex;align-items:flex-start;margin-bottom:4px;line-height:1.43;> svg{width:16px;height:16px;}"]);
export const PassengerName = styled.div.withConfig({
  displayName: "Style__PassengerName",
  componentId: "sc-oqhgzm-7"
})(["margin-bottom:4px;margin-left:7px;"]);
export const PassengerDetails = styled.div.withConfig({
  displayName: "Style__PassengerDetails",
  componentId: "sc-oqhgzm-8"
})(["font-size:", "px;color:", ";"], ({
  theme: {
    fontSize
  }
}) => fontSize.sm, ({
  theme: {
    color
  }
}) => color.grayText);
export const TicketNumber = styled.span.withConfig({
  displayName: "Style__TicketNumber",
  componentId: "sc-oqhgzm-9"
})(["margin-right:45px;margin-left:7px;", ""], media.sm`
    margin-right: 24px;
  `);
export const Status = styled.div.withConfig({
  displayName: "Style__Status",
  componentId: "sc-oqhgzm-10"
})(["display:flex;margin-left:26px;font-size:", "px;", ""], ({
  theme: {
    fontSize
  }
}) => fontSize.sm, media.sm`
    margin-top: 5px;
    margin-left: 20px;
  `);
export const LuggageIcon = styled(luggageSvg).withConfig({
  displayName: "Style__LuggageIcon",
  componentId: "sc-oqhgzm-11"
})(["path{fill:", ";}"], ({
  theme: {
    color
  }
}) => color.primary);
export const PassengerIcon = styled(passengerSvg).withConfig({
  displayName: "Style__PassengerIcon",
  componentId: "sc-oqhgzm-12"
})(["path{fill:", ";}"], ({
  theme: {
    color
  }
}) => color.primary);